import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import './UnCollapsibleMenu.scss';

interface UnCollapsibleMenuProps {
    titleText: string;
    link: string;
    image: string;
    selectedImage?: string;
}

const UnCollapsibleMenu: React.FC<UnCollapsibleMenuProps> = ({ titleText, link, image, selectedImage }) => {
    const location = useLocation();

    return (
        <div
            className="UnCollapsibleMenuComponent"
            // style={{ marginTop: titleText == '대시보드' ? 0 : '13.5px' }}
        >
            <Link to={link}>
                <div
                    className="titleContainer"
                    style={{
                        backgroundColor: location.pathname == link ? '#E5F4F2' : '',
                        color: location.pathname == link ? '#075453' : '',
                    }}
                >
                    <div className="titleTextAndImage">
                        <div className="titleImage">
                            <img src={image} hidden={location.pathname == link} alt="" />
                            <img src={selectedImage} alt="" hidden={location.pathname != link} />
                        </div>
                        <div className="titleText">{titleText}</div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default UnCollapsibleMenu;
